import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetFiltersStatus } from "./filtersSlice";
export const login = createAsyncThunk(
  "auth/login",
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("username", username);
      formData.append("password", password);

      const response = await fetch(
        process.env.REACT_APP_API_URL + "clientPortal/SignIn",
        {
          method: "POST",
          body: formData,
        },
      );
      if (!response.ok) {
        throw new Error("Invalid username or password");
      }

      const data = await response.json();
      if (!data.token) {
        throw new Error("Invalid username or password");
      }

      // Save the token, group_code, and company_code in sessionStorage
      sessionStorage.setItem("token", data?.token);
      sessionStorage.setItem("group_code", data?.group_code);
      sessionStorage.setItem("company_code", data?.company_code);
      sessionStorage.setItem("company", data?.company);
      sessionStorage.setItem("curId", data?.currency);
      sessionStorage.setItem("cur", data?.symbol);
      sessionStorage.setItem("aux", data?.aux);
      sessionStorage.setItem("company_name", data?.company_name);
      sessionStorage.setItem("aux_name", data?.aux_name);
      sessionStorage.setItem("address_id", data?.address_id);
      sessionStorage.setItem("prec", data?.prec);
      sessionStorage.setItem("user_id", data?.user_id);
      sessionStorage.setItem("display_stock", data?.display_stock);
      sessionStorage.setItem("display_stock_name", data?.display_stock_name);
      sessionStorage.setItem("pricelist", data?.pricelist);

      return data;
    } catch (error) {
      return rejectWithValue(error?.message);
    }
  },
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isLoading: false,
    error: null,
  },
  reducers: {
    logoutReducer: (state) => {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("group_code");
      sessionStorage.removeItem("company_code");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

// Create a function to retrieve the values from sessionStorage
export const getAuthData = () => {
  return {
    token: sessionStorage.getItem("token"),
    groupCode: sessionStorage.getItem("group_code"),
    companyCode: sessionStorage.getItem("company_code"),
    company: sessionStorage.getItem("company"),
    aux: sessionStorage.getItem("aux"),
    user_id: sessionStorage.getItem("user_id"),
    pricelist: sessionStorage.getItem("pricelist"),
  };
};
export const logout = () => (dispatch) => {
  dispatch(authSlice.actions.logoutReducer()); // Clear auth state
  dispatch(resetFiltersStatus()); // Reset filters state
};
export default authSlice.reducer;
